// extracted by mini-css-extract-plugin
export default {"tabs":"Trash_tabs__4Ftl4","tab":"Trash_tab__JBQ5n","tabActive":"Trash_tabActive__ntSks","tabCount":"Trash_tabCount__H83nX","draft":"Trash_draft__8WSut"};